import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { Bar, Column, Line, Pie } from "@ant-design/plots";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

const RegionWiseDashboard = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined || num === "") return "0";

    const number = Number(num);

    if (isNaN(number)) return num;

    return number.toLocaleString("en-US");
  };


  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegiondata] = useState([]);
  const [graphFilter, setGraphFilter] = useState("All");

  const [regionId, setRegionId] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [seasonId, setSeasonId] = useState([]);
  const [seasondata, setSeasondata] = useState([]);
  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);


  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);
  const [cropData, setCropData] = useState([]);

  const [loading, setLoading] = useState(false);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);

  const plotItems = data?.byPlot?.rows || [];
  const dateItems = data?.byDate?.rows || [];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = plotItems.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const shortenLabel = (text) => {
    if (!text) return "";

    const words = text.split(" ");
    const shortText = words.slice(0, 2).join(" ");

    return words.length > 2 ? shortText + "..." : shortText;
  };


  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);
  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);
  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getRegionWiseDashboardData } = useHttp();

  const fillRegionWiseDashboardData = (getType = "") => {
    var urlfilter = "";

    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (seasonId > 0) urlfilter += `&seasonId=${seasonId}`;
    if (showDateFilter) {
      urlfilter += `&fromDate=${selectedFromDate}`;
      urlfilter += `&toDate=${selectedToDate}`;
    }
    if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
    if (farmerNumber != "") urlfilter += `&farmerNo=${farmerNumber}`;

    var url = `/api/regionWiseDashboard/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getRegionWiseDashboardData({ url: url }, (res) => {
      setData(res);
    });
  };

  const { sendRequest: getCropWiseDashboardData } = useHttp();

  const fillCropWiseDashboardData = () => {
    let urlfilter = "";

    if (ranchId > 0) urlfilter += `&ranchId=${ranchId}`;
    if (seasonId > 0) urlfilter += `&seasonId=${seasonId}`;
    if (showDateFilter) {
      urlfilter += `&fromDate=${selectedFromDate}`;
      urlfilter += `&toDate=${selectedToDate}`;
    }
    if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
    if (farmerNumber !== "") urlfilter += `&farmerNo=${farmerNumber}`;

    const url = `/api/cropWiseDashboard/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getCropWiseDashboardData({ url }, (res) => {
      setCropData(res);
    });
  };


  useEffect(() => {
    fillRegionWiseDashboardData();
    fillCropWiseDashboardData();
  }, []);


  const handleExport = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    const workbook = XLSX.utils.book_new();

    const allKeys = Array.from(
      new Set(
        data.regionList.flatMap((obj) =>
          Object.keys(obj).filter((k) => k !== "regionName")
        )
      )
    );

    const headers = ["Region", ...allKeys];
    const sheetData = [headers];

    data.regionList.forEach((row) => {
      sheetData.push([
        row.regionName,
        ...allKeys.map((k) =>
          row[k] !== undefined && row[k] !== null ? row[k] : 0
        ),
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    worksheet["!freeze"] = { xSplit: 1, ySplit: 1 };

    worksheet["!cols"] = headers.map((h, i) => {
      const columnCells = sheetData.map((row) => String(row[i] ?? ""));
      const maxLength = Math.max(...columnCells.map((v) => v.length));
      return { wch: maxLength + 2 };
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, "Region Table");
    XLSX.writeFile(workbook, "Region Wise Dashboard.xlsx");
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getSeasonData } = useHttp();
  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setSeasondata(data);
      }
    );
  }, [getSeasonData]);

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/cropFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);


  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  console.log("filteredOptions", filteredOptions)

  const RegionWiseChartConfig = (data) => ({
    data: data.data.flatMap((metric) =>
      Object.entries(metric.values)
        .filter(([region]) => region !== "Total") // ⭐ REMOVE TOTAL
        .map(([region, value]) => ({
          metric: metric.headerName,
          region,
          value: Number(value) || 0,
        }))
    ),

    isGroup: true,
    xField: "metric",
    yField: "value",
    seriesField: "region",

    columnWidthRatio: 0.5, // ⭐ slightly slimmer bars (more breathing space)
    dodgePadding: 6, // ⭐ spacing between grouped bars
    intervalPadding: 20, // ⭐ spacing between categories

    columnStyle: { radius: [4, 4, 0, 0] },

    xAxis: {
      title: { text: "Metrics" },
      label: {
        formatter: (text) => shortenLabel(text),
        autoRotate: false,
        autoHide: false,
        rotate: 0,
        style: {
          fontWeight: 600,
          fontSize: 12,
        },
      },
    },

    yAxis: {
      title: { text: "Value" },
      min: 0,
    },

    // ⭐⭐⭐ EXPANDED LEGEND (THIS FIXES YOUR ISSUE)
    legend: {
      position: "top",
      itemSpacing: 24, // ⭐ space between Boston / California
      itemName: {
        style: {
          fontSize: 14,
          fontWeight: 600,
        },
      },
      marker: {
        style: {
          r: 6,
        },
      },
    },
  });

  const CropWiseChartConfig = (data) => ({
    data: data.data.flatMap((metric) =>
      Object.entries(metric.values)
        .filter(([region]) => region !== "Total")
        .map(([region, value]) => ({
          metric: metric.headerName,
          region,
          value: Number(value) || 0,
        }))
    ),

    isGroup: true,
    xField: "metric",
    yField: "value",
    seriesField: "region",

    columnWidthRatio: 0.6,
    columnStyle: { radius: [4, 4, 0, 0] },

    xAxis: {
      title: { text: "Metrics" },
      label: {
        formatter: (text) => shortenLabel(text),
        autoRotate: false,
        autoHide: false,
        rotate: 0,
        style: {
          fontWeight: 600,
          fontSize: 12,
        },
      },


    },
    yAxis: {
      title: { text: "Value" },
      min: 0,
    },
    legend: { position: "top" },
  });





  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title mx-3">Location Dashboard</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season Name</label>
                  <select
                    id="seasonId"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonId"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      var sId = "";
                      if (e.target.value != "--Select--") {
                        sId = e.target.value;
                      }
                      // setSeasonName(sName);
                      setSeasonId(sId);
                      EmployeeDetail(sId);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {seasondata &&
                      seasondata.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch</label>
                  <select
                    id="ranch"
                    className="form-control"
                    value={ranchId}
                    onChange={(e) => setRanchId(e.target.value || 0)}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>


              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Field Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}

              {/* Farmer Number */}
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>

              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Apply Date Filter</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )} */}

              {/* Submit */}
              <div className="col-md-3 text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={() => {
                      fillRegionWiseDashboardData();
                      fillCropWiseDashboardData();
                    }}

                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        {/* Report Table */}
        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-success mx-2"
                onClick={handleExport}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div
                    className="card-body"
                    style={{ padding: "0.4rem", marginTop: 15 }}
                  >
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Graph Filter</label>
                        <select
                          className="form-control"
                          value={graphFilter}
                          onChange={(e) => setGraphFilter(e.target.value)}
                        >
                          <option value="All">All</option>
                          <option value="Region">Region</option>
                          <option value="Crop">Crop</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-12">

                      {/* ✅ REGION SECTION */}
                      {(graphFilter === "All" || graphFilter === "Region") && (
                        <>
                          <div className="card" title="Region Wise Graph">
                            <div className="card-header bg-info text-white fw-bold">
                              Region Category Wise Graph
                            </div>
                            <div
                              className="card-body"
                              style={{ height: 420, marginBottom: 30 }}
                            >
                              {data?.data && data.data.length > 0 ? (
                                <div style={{ width: "100%", overflowX: "auto" }}>
                                  <div
                                    style={{
                                      minWidth: `${(data?.data?.length || 1) * 100}px`,
                                      height: "100%",
                                    }}
                                  >
                                    <Column {...RegionWiseChartConfig(data)} />
                                  </div>

                                </div>
                              ) : (
                                <div className="text-center">No data available</div>
                              )}
                            </div>
                          </div>

                          <div className="card" title="Region Wise Table">
                            <div className="card-header bg-info text-white fw-bold">
                              Region Category Wise Table
                            </div>

                            <div className="card-body" style={{ backgroundColor: "#cce7efff" }}>
                              {Array.isArray(data?.data) && data.data.length > 0 && (
                                <div className="table-responsive">
                                  <table className="table table-sm text-center">
                                    <thead style={{ backgroundColor: "#000", color: "#fff" }}>
                                      <tr>
                                        <th style={{ padding: "8px", border: "1px solid black" }}>
                                          Category
                                        </th>

                                        {[
                                          ...Object.keys(data.data[0]?.values || {}).filter(k => k !== "Total"),
                                          "Total"
                                        ].map((key, index) => (
                                          <th
                                            key={index}
                                            style={{ padding: "8px", border: "1px solid black" }}
                                          >
                                            {key}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {data.data.map((row, index) => (
                                        <tr key={index}>
                                          <td style={{ padding: "8px", border: "1px solid black" }}>
                                            <strong>
                                              {row.headerName === "cropDisplayName"
                                                ? "Crop Name"
                                                : row.headerName === "seasonName"
                                                  ? "Season Name"
                                                  : row.headerName}
                                            </strong>
                                          </td>

                                          {Object.values(row?.values || {}).map((value, i) => (
                                            <td
                                              key={i}
                                              style={{ padding: "8px", border: "1px solid black" }}
                                            >
                                              {typeof value === "number"
                                                ? formatNumber(value)
                                                : value}
                                            </td>
                                          ))}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          </div>

                        </>
                      )}

                      {/* ✅ CROP SECTION */}
                      {(graphFilter === "All" || graphFilter === "Crop") && (
                        <div className="col-12 mt-4">
                          <div className="card" title="Crop Wise Graph">
                            <div className="card-header bg-success text-white fw-bold">
                              Crop Wise Category Graph
                            </div>
                            <div
                              className="card-body"
                              style={{ height: 420, marginBottom: 30 }}
                            >
                              {cropData?.data && cropData.data.length > 0 ? (
                                <div style={{ width: "100%", overflowX: "auto" }}>
                                  <div
                                    style={{
                                      minWidth: `${(cropData?.data?.length || 1) * 100}px`,
                                      height: "100%",
                                    }}
                                  >
                                    <Column {...CropWiseChartConfig(cropData)} />
                                  </div>
                                </div>
                              ) : (
                                <div className="text-center">No crop data available</div>
                              )}
                            </div>

                            <div className="card mt-4" title="Crop Wise Table">
                              <div className="card-header bg-success text-white fw-bold">
                                Crop Wise Category Table
                              </div>

                              <div
                                className="card-body"
                                style={{ backgroundColor: "#eaf8ec" }}
                              >
                                {Array.isArray(cropData?.data) &&
                                  cropData.data.length > 0 && (
                                    <div className="table-responsive">
                                      <table className="table table-sm text-center">
                                        <thead style={{ backgroundColor: "#000", color: "#fff" }}>
                                          <tr>
                                            <th style={{ padding: "8px", border: "1px solid black" }}>
                                              Category
                                            </th>

                                            {Object.keys(cropData.data[0]?.values || {}).map(
                                              (key, index) => (
                                                <th
                                                  key={index}
                                                  style={{ padding: "8px", border: "1px solid black" }}
                                                >
                                                  {key}
                                                </th>
                                              )
                                            )}
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {cropData.data.map((row, index) => (
                                            <tr key={index}>
                                              <td style={{ padding: "8px", border: "1px solid black" }}>
                                                <strong>{row.headerName}</strong>
                                              </td>

                                              {Object.values(row?.values || {}).map((value, i) => (
                                                <td
                                                  key={i}
                                                  style={{ padding: "8px", border: "1px solid black" }}
                                                >
                                                  {typeof value === "number"
                                                    ? formatNumber(value)
                                                    : value}
                                                </td>
                                              ))}
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>



                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RegionWiseDashboard;
